var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductForm',{attrs:{"title":"Add product","request-tag":_vm.requestTag,"product":_vm.product},on:{"save":_vm.onCreate,"close":function($event){return _vm.$router.back()}}})}
var staticRenderFns = []

export { render, staticRenderFns }